export default __webpack_public_path__ + "static/logo-8bit-horiz-dcc0ff3bcc289c8004b9619f1ef12a98.svg";